import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.381 3.582A3.333 3.333 0 0 1 20.146.745L35 2.832a3.333 3.333 0 0 1 2.837 3.765l-2.552 18.155a3.333 3.333 0 0 1-3.764 2.837l-2.622-.368-.943-6.865 4.492.631 2.088-14.854-14.854-2.088-.481 3.426-3.44.525.62-4.414ZM5 12.832a3.333 3.333 0 0 0-2.837 3.765l2.551 18.155A3.333 3.333 0 0 0 8.48 37.59l14.854-2.087a3.333 3.333 0 0 0 2.837-3.765L23.62 13.582a3.333 3.333 0 0 0-3.765-2.837L5 12.833Zm2.81 8.02a1.667 1.667 0 1 0-.464-3.3 1.667 1.667 0 0 0 .464 3.3Zm13.436-.205 1.391 9.903-3.714.522-11.14 1.566 4.735-6.725 3.203 2.58 5.525-7.846Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { ImagesEmpty40 } from '@cian/ui-kit/icons';`, <br />
 * где 40 - это размер иконки в пикселях.
 */
export var ImagesEmpty40 = createIcon(IconComponent);